import { render, staticRenderFns } from "./survey-details.vue?vue&type=template&id=8dd633d6&scoped=true&"
import script from "./survey-details.vue?vue&type=script&lang=js&"
export * from "./survey-details.vue?vue&type=script&lang=js&"
import style0 from "./survey-details.vue?vue&type=style&index=0&id=8dd633d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd633d6",
  null
  
)

component.options.__file = "survey-details.vue"
export default component.exports